import { Text } from '@/shared/ui/primitives';
import type { FC, ReactNode } from 'react';

import styles from './ClientSubPageLayout.module.css';

interface ClientSubPageLayoutProps {
  title: string;
  subtitle: string;
  titleTestId?: string;
  action?: ReactNode;
  activeHeader?: ReactNode;
  isHeaderActive?: boolean;
  children: ReactNode;
}

export const ClientSubPageLayout: FC<ClientSubPageLayoutProps> = ({
  title,
  subtitle,
  titleTestId,
  action,
  activeHeader,
  isHeaderActive = false,
  children,
}) => {
  return (
    <div className={styles.container}>
      {isHeaderActive ? (
        <div className={styles.activeHeader}>{activeHeader}</div>
      ) : (
        <div className={styles.header}>
          <div className={styles.titleBlock}>
            <Text variant="title" as="h1" weight="medium" data-testid={titleTestId}>
              {title}
            </Text>
            <Text variant="caption" weight="regular" className={styles.subtitle}>
              {subtitle}
            </Text>
          </div>
          {action && <div className={styles.actions}>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
};
